export const useSubmitFeedback = async (data) => {
  safeRemoveStoredItem("createOrder");
  return useFetchSafely(() => `customer-general-feedback`, {
    method: "POST",
    body: data,
  });
};

export const useUpdateFeedback = async (id, data) => {
  safeRemoveStoredItem("createOrder");
  return useFetchSafely(() => `customer-general-feedback/${id}`, {
    method: "POST",
    body: data,
  });
};
